export const CHURN_REASONS = {
  too_expensive: 'too_expensive',
  not_enough_time: 'not_enough_time',
  not_enough_features: 'not_enough_features',
} as const;

export type ChurnReason = typeof CHURN_REASONS[keyof typeof CHURN_REASONS];

export type FreeTrialStateCompany = {
  unconvertedFlowEnded: boolean;
  discountAvailableUntil: Date | null;
};

export type FreeTrialStateUser = {
  trialStartedModalClosed: boolean;
  midTrialModalClosed: boolean;
  trialWalkthrough: {
    displayRenderCounter: boolean;
    renderCounterViewed: boolean;
    displayCacheFreshness: boolean;
    cacheFreshnessViewed: boolean;
  };
  trialEndedModalClosed: boolean;
  displayChurnModal: boolean;
  churnFollowupModal: ChurnReason | null;
};

export type FreeTrialState = {
  user: FreeTrialStateUser;
  company: FreeTrialStateCompany;
};

export const INITIAL_STATE_FREE_TRIAL_USER: FreeTrialStateUser = {
  trialStartedModalClosed: false,
  midTrialModalClosed: false,
  trialWalkthrough: {
    displayCacheFreshness: false,
    cacheFreshnessViewed: false,
    displayRenderCounter: false,
    renderCounterViewed: false,
  },
  trialEndedModalClosed: false,
  displayChurnModal: false,
  churnFollowupModal: null,
};

export const INITIAL_STATE_FREE_TRIAL_COMPANY: FreeTrialStateCompany = {
  unconvertedFlowEnded: false,
  discountAvailableUntil: null,
};
